// extracted by mini-css-extract-plugin
export default {"overlay":"PageLoader_overlay__uxj65","loader":"PageLoader_loader__Q-M05"};